import {useState} from "react";
import {useSearchParams} from "react-router-dom";
import useCustomPaging from "@/hooks/useCustomPaging";

const useSearchFilter = () => {
  const [searchParams] = useSearchParams()
  const [, changeFilterWithoutPage] = useCustomPaging()
  const currentSearchFilter = searchParams.get('search') ?? ''
  const [searchString, setSearchString] = useState(currentSearchFilter)
  
  const handleSubmitSearch = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault()
      changeFilterWithoutPage('search', searchString)
    }
  }
  
  const handleChangeSearchString = (e): void => {
    setSearchString(e.target.value)
  }
  
  return [
    searchString,
    currentSearchFilter,
    handleChangeSearchString,
    handleSubmitSearch
  ] as const
}

export default useSearchFilter